/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "letter-plus-e05b94ef--sprite",
  "use": "letter-plus-e05b94ef--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"letter-plus-e05b94ef--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(-725.507 -1291.939)\"><path d=\"M751.555,1306.043v3.4h-.021a6.209,6.209,0,0,0-6.2,6.2H734.623a2.122,2.122,0,0,1-2.116-2.116v-7.482a.537.537,0,0,1,.529-.529.5.5,0,0,1,.3.1l8.7,5.8,8.709-5.8a.517.517,0,0,1,.719.132h0l.01.015A.531.531,0,0,1,751.555,1306.043Z\" fill=\"currentColor\" /><path d=\"M750.1,1303.909l-8.07,5.38-8.07-5.38a.529.529,0,0,1,.293-.969h15.556a.529.529,0,0,1,.291.969Z\" fill=\"currentColor\" /><path d=\"M756.163,1314.193a5.193,5.193,0,0,0-.26-.65,4.425,4.425,0,0,0-.34-.6,4.839,4.839,0,0,0-1.32-1.31c-.13-.08-.26-.16-.4-.24a4.917,4.917,0,0,0-2.3-.58,4.825,4.825,0,1,0,4.75,5.73,4.141,4.141,0,0,0,.09-.87v-.05A4.808,4.808,0,0,0,756.163,1314.193Zm-1.91,1.42a.524.524,0,0,1-.51.56h-1.65v1.6a.525.525,0,0,1-.48.56h-.03a.535.535,0,0,1-.56-.51v-1.65h-1.57a.529.529,0,0,1-.54-.53.543.543,0,0,1,.49-.54.045.045,0,0,1,.05,0h1.57v-1.57a.549.549,0,0,1,.53-.54.543.543,0,0,1,.54.49.044.044,0,0,1,0,.05v1.57h1.6a.526.526,0,0,1,.56.49Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
